import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'OrganizedUnit/GetAllLegalCompany', method: 'POST', body: filter, token: token })
}
